import * as React from 'react';
import styled from 'styled-components';

import { themeGet, Icon, IconNames } from '@packages/ui';

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  position: relative;
`;
const StyledIcon = styled(Icon)`
  min-width: 25px;
  width: 25px;
  max-width: 25px;
  min-height: 25px;
  height: 25px;
  max-height: 25px;
  margin-right: 10px;
  color: ${themeGet.colors('black')};
`;

export interface IconTextProps {
  icon: IconNames;
  children: React.ReactNode;
}

export const IconText: React.FC<IconTextProps> = ({ icon, children }) => (
  <Container>
    <StyledIcon name={icon} color="black" />
    {children}
  </Container>
);
